(() => {
  const dlg = document.getElementById('vt-meterkast');
  if (!dlg || dlg.dataset.klaar) return;
  dlg.dataset.klaar = '1';

  let T = {};
  try { T = JSON.parse(dlg.querySelector('[data-mk-teksten]').textContent); } catch (_) {}
  const vul = (s, w) => Object.entries(w).reduce((t, [k, v]) => t.split(`[${k}]`).join(v), s || '');

  const schermen = [...dlg.querySelectorAll('[data-mk-scherm]')];
  const vragen = schermen.filter((s) => s.dataset.mkScherm === 'vraag');
  const titel = dlg.querySelector('[data-mk-titel]');

  let pad = [];
  let nu = null;
  let antwoorden = {};

  function toon(scherm, kop) {
    schermen.forEach((s) => { s.hidden = s !== scherm; });
    nu = scherm;
    titel.textContent = kop || T.titel || titel.textContent;
    const focus = scherm.querySelector('[tabindex="-1"]') || titel;
    focus.focus({ preventScroll: true });
    scherm.parentElement.scrollTop = 0;
  }

  function naar(scherm, kop) {
    if (nu && nu !== scherm) pad.push(nu);
    toon(scherm, kop);
  }

  function open(welke) {
    pad = [];
    antwoorden = {};
    if (welke === 'p1') {
      const s = schermen.find((x) => x.dataset.mkScherm === 'uitleg-p1');
      if (!s) return;
      window.VtDialoog.open(dlg);
      toon(s, s.dataset.mkKop);
    } else {
      window.VtDialoog.open(dlg);
      toon(vragen[0]);
    }
  }

  let wachtend = null;

  function radio(code) {
    return document.querySelector(`.vt-lb-optie[data-vt-lb="${code}"] input`);
  }

  function uitkomst(code, reden) {
    const r = radio(code);
    const tekst = vul(T.melding, { optie: T.optie?.[code] || code, reden });
    if (r) {
      wachtend = { code, tekst, getoond: false };
      window.VtDialoog.sluit(dlg);
      if (r.checked) plaats();
      else r.click();
      return;
    }
    const s = schermen.find((x) => x.dataset.mkScherm === 'uitkomst');
    s.querySelector('[data-mk-uitkomst-kop]').textContent = code === 'geen'
      ? T.uitkomstGeen
      : vul(T.uitkomst, { optie: T.optie?.[code] || code });
    s.querySelector('[data-mk-uitkomst-reden]').textContent =
      [reden, code === 'geen' ? T.geen : ''].filter(Boolean).join(' ');
    s.querySelector('[data-mk-noot]').hidden = code === 'geen';
    naar(s);
  }

  function plaats() {
    if (!wachtend) return;
    const slot = document.querySelector('[data-vt-lb-melding]');
    if (!slot) return;
    if (slot.dataset.gekozen !== wachtend.code) {
      if (wachtend.getoond) wachtend = null;
      return;
    }
    if (slot.textContent !== wachtend.tekst) slot.textContent = wachtend.tekst;
    slot.hidden = false;
    wachtend.getoond = true;
  }

  new MutationObserver(() => plaats()).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', (e) => {
    const t = e.target instanceof Element ? e.target : null;
    const opener = t?.closest('[data-vt-meterkast], a[href$="#vt-meterkast"]');
    if (!opener || dlg.contains(opener)) return;
    const link = opener.tagName === 'A' ? new URL(opener.href, location.href) : null;
    if (link && link.pathname !== location.pathname) return;
    e.preventDefault();
    open(opener.dataset.vtMeterkast || 'check');
  });

  const viaLink = () => { if (location.hash === '#vt-meterkast') open('check'); };
  if (window.VtDialoog) viaLink();
  else document.addEventListener('DOMContentLoaded', viaLink);

  dlg.addEventListener('click', (e) => {
    const t = e.target instanceof Element ? e.target : null;
    if (!t) return;

    if (t.closest('[data-mk-sluit]')) return window.VtDialoog.sluit(dlg);

    if (t.closest('[data-mk-terug]')) {
      const vorig = pad.pop();
      if (vorig) toon(vorig);
      return;
    }

    const knop = t.closest('[data-mk-antw]');
    if (!knop) return;
    const vraag = knop.closest('[data-mk-vraag]');
    const sleutel = vraag.dataset.mkVraag;
    const antw = knop.dataset.mkAntw;

    antwoorden[sleutel] = antw;
    if (antw === 'nee' && sleutel !== 'wifi') return uitkomst('geen', T.reden?.[`nee_${sleutel}`] || '');

    const volgende = vragen[vragen.indexOf(vraag) + 1];
    if (volgende) return naar(volgende);

    const open = vragen.map((v) => v.dataset.mkVraag).filter((k) => antwoorden[k] === 'weet');
    if (open.length) foto(open);
    else uitkomst('p1', (antwoorden.wifi === 'nee' ? T.reden?.p1_wifi : T.reden?.p1) || '');
  });

  function lijst(delen) {
    if (delen.length < 2) return delen.join('');
    return `${delen.slice(0, -1).join(', ')} ${T.en || 'en'} ${delen[delen.length - 1]}`;
  }

  function foto(open) {
    const s = schermen.find((x) => x.dataset.mkScherm === 'foto');
    const regel = vul(T.fotoOpen, { open: lijst(open.map((k) => T.open?.[k] || k)) });
    const vak = s.querySelector('[data-mk-open]');
    vak.textContent = regel;
    vak.hidden = false;
    const mail = s.querySelector('[data-mk-mail]');
    const basis = mail.dataset.basis || mail.getAttribute('href');
    mail.dataset.basis = basis;
    mail.setAttribute('href', `${basis}&body=${encodeURIComponent(regel)}`);
    naar(s);
  }
})();

